// extracted by mini-css-extract-plugin
module.exports = {"date_picker_holder":"style_date_picker_holder__26vUu","calendar":"style_calendar__27PD5"};